import {connect, Dispatch} from 'react-redux';
import VersionsMenu, {VersionsMenuProps} from './VersionsMenu';
import ReduxState from '../../types/ReduxState';
import {ModalStates} from '../../globals/Constants';
import Action from '../../redux/Actions';
import ReviewVersionModel from '../../types/ReviewVersionModel';

const mapStateToProps = (state: ReduxState, ownProps: VersionsMenuContainerProps): Partial<VersionsMenuProps> => {
   return {
      reviewVersions: state.currentReview.ReviewVersions,
      currentVersionNumber: state.currentReviewVersion.VersionNumber || 1,
      reviewId: state.currentReview.Id,
      isOwner: state.isOwner,
      deleteVersion: ownProps.deleteVersion
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<VersionsMenuProps> => {
   return {
      setModalState: (modalState: ModalStates) => {
         dispatch(Action.setModalState({modalState}));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(VersionsMenu);

interface VersionsMenuContainerProps {
   deleteVersion(version: ReviewVersionModel): void;
}
